import { SOCIAL_MEDIA_TYPES } from 'actions/socialMedia';
export const MERCHANT_SUGGESTION_TYPES = [
    ...SOCIAL_MEDIA_TYPES,
    'WEB_DOMAIN',
];
